import { render, staticRenderFns } from "./DeleteMultipleGroupDialog.vue?vue&type=template&id=be421852&scoped=true"
import script from "./DeleteMultipleGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteMultipleGroupDialog.vue?vue&type=style&index=0&id=be421852&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be421852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be421852')) {
      api.createRecord('be421852', component.options)
    } else {
      api.reload('be421852', component.options)
    }
    module.hot.accept("./DeleteMultipleGroupDialog.vue?vue&type=template&id=be421852&scoped=true", function () {
      api.rerender('be421852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/DeleteMultipleGroupDialog.vue"
export default component.exports